import type { EmailValidationResponse } from '@atlaskit/user-picker';

export const INVITE_AND_ASSIGN_ID = '_INVITE_AND_ASSIGN_ID_';
export const validOption: EmailValidationResponse = 'VALID';
export const potentialOption: EmailValidationResponse = 'POTENTIAL';
